// EcomCatalogEmbedPage — eCommerce catalog + sepet + sipariş HTML/JS embed kodu.
// Müşteri kendi sitesine yapıştırır; ürünler hent'in publish edilmiş stoklarından çekilir.
import React, { useState, useMemo } from 'react';
import { useAuth } from '../context/AuthContext';
import { Button, ListPageHeader } from '../components/ui';
import { toast } from '../components/Toast';

export default function EcomCatalogEmbedPage() {
  const { company } = useAuth();
  const [copied, setCopied] = useState(null);

  const API_BASE = useMemo(() => (typeof window !== 'undefined' ? window.location.origin : 'https://erp.asistanyazilim.com.tr'), []);
  const code = company?.code || 'YOUR_COMPANY_CODE';

  const htmlSnippet = `<!-- hent E-Ticaret Katalog — başla -->
<div id="hent-shop" style="font-family:system-ui,sans-serif;max-width:1100px;margin:0 auto"></div>
<script>
(function(){
  var API = '${API_BASE}/api/ecom/public';
  var CODE = '${code}';
  var root = document.getElementById('hent-shop');
  var cart = [];

  function fmt(n){ return parseFloat(n||0).toLocaleString('tr-TR',{minimumFractionDigits:2,maximumFractionDigits:2}); }

  function renderCatalog(){
    root.innerHTML = '<div style="display:flex;gap:10px;margin-bottom:14px"><input id="hent-q" placeholder="Ara..." style="flex:1;padding:10px;border:1px solid #d1d9e0;border-radius:6px;font-size:15px"><button id="hent-cart-btn" style="padding:10px 16px;background:#1d6ef5;color:#fff;border:0;border-radius:6px;cursor:pointer">🛒 Sepet (<span id="hent-cart-n">0</span>)</button></div><div id="hent-grid" style="display:grid;grid-template-columns:repeat(auto-fill,minmax(220px,1fr));gap:12px"></div>';
    document.getElementById('hent-cart-btn').onclick = openCart;
    document.getElementById('hent-q').addEventListener('input', function(e){
      clearTimeout(window.__hentSearch);
      window.__hentSearch = setTimeout(function(){ load(e.target.value); }, 300);
    });
    load('');
  }

  // Aynı (product_code, color_id) paylaşanları tek karta grupla — bedenler içeride seçilir.
  function groupItems(items){
    var map = {};
    items.forEach(function(it){
      var pcode = it.product_code || it.id; // product_code yoksa kendi başına
      var ckey  = it.color_id || 'no-color';
      var key   = pcode + '||' + ckey;
      if (!map[key]) {
        map[key] = {
          key: key,
          base_name: it.name,
          color_name: it.color_name || '',
          color_code: it.color_code || '',
          image_url: it.image_url,
          product_code: it.product_code,
          variants: [],
        };
      }
      var p = parseFloat(it.price1);
      map[key].variants.push({
        id: it.id, code: it.code, name: it.name,
        size_name: it.size_name, size_id: it.size_id,
        stock: parseFloat(it.current_stock)||0,
        price: isFinite(p) && p > 0 ? p : null,
        has_price: !!it.has_ecom_price && isFinite(p) && p > 0,
      });
    });
    var groups = Object.values(map);
    groups.forEach(function(g){
      // Base name: tek varyantsa kendi adı, çoklu ise bedeni kırp
      if (g.variants.length === 1) {
        g.display_name = g.variants[0].name;
      } else {
        // bedenleri uca alarak ortak prefix bul (basit yaklaşım: ilk varyantın isminden beden adını çıkar)
        var first = g.variants[0];
        var sz = first.size_name || '';
        var clean = first.name;
        if (sz) clean = clean.replace(new RegExp('\\s*' + sz.replace(/[.*+?^\${}()|[\\]\\\\]/g,'\\\\$&') + '\\s*\$', 'i'), '').trim();
        g.display_name = clean || g.base_name;
      }
      // Beden sıralama
      var sizeOrder = ['XXS','XS','S','M','L','XL','XXL','XXXL','3XL','4XL','5XL'];
      g.variants.sort(function(a,b){
        var ai = sizeOrder.indexOf((a.size_name||'').toUpperCase());
        var bi = sizeOrder.indexOf((b.size_name||'').toUpperCase());
        if (ai < 0) ai = 999; if (bi < 0) bi = 999;
        if (ai !== bi) return ai - bi;
        return (a.size_name || '').localeCompare(b.size_name || '', 'tr');
      });
      g.has_sizes = g.variants.length > 1 || g.variants[0].size_name;
    });
    return groups;
  }

  function load(q){
    var grid = document.getElementById('hent-grid');
    grid.innerHTML = '<div style="grid-column:1/-1;text-align:center;color:#94a3b8">Yükleniyor...</div>';
    fetch(API+'/catalog/'+CODE+(q?'?search='+encodeURIComponent(q):'')).then(function(r){return r.json();}).then(function(j){
      if (!j.success){ grid.innerHTML = '<div style="grid-column:1/-1;color:#dc2626">'+(j.message||'Yüklenemedi')+'</div>'; return; }
      if (!j.data.items.length){ grid.innerHTML = '<div style="grid-column:1/-1;color:#94a3b8">Ürün bulunamadı</div>'; return; }
      var groups = groupItems(j.data.items);
      grid.innerHTML = groups.map(function(g, gi){
        var firstV = g.variants[0];
        var priceTxt = firstV.has_price ? (fmt(firstV.price) + ' ₺') : '<span style="color:#dc2626;font-size:12px;font-weight:600">Fiyat Tanımsız</span>';
        var canAdd = firstV.has_price && firstV.stock > 0;
        var colorChip = g.color_name ? '<span style="display:inline-flex;align-items:center;gap:4px;font-size:11px;color:#5a6a7e;background:#f4f6fa;padding:1px 6px;border-radius:999px"><span style="width:8px;height:8px;border-radius:50%;background:'+(g.color_code||'#94a3b8')+';display:inline-block"></span>'+g.color_name+'</span>' : '';
        var sizeButtons = g.has_sizes ? '<div data-group="'+gi+'" style="display:flex;flex-wrap:wrap;gap:4px;margin:6px 0">' + g.variants.map(function(v, vi){
          var out = v.stock <= 0;
          var np  = !v.has_price;
          var dis = out || np;
          return '<button class="hent-size" data-group="'+gi+'" data-vi="'+vi+'" '+(dis?'disabled':'')+' title="'+(np?'Fiyat tanımsız':(out?'Stokta yok':''))+'" style="padding:4px 10px;font-size:11px;font-weight:600;border:1px solid '+(vi===0?'#1d6ef5':'#d1d9e0')+';background:'+(vi===0?'rgba(29,110,245,0.1)':(dis?'#f0f2f5':'#fff'))+';color:'+(dis?'#9aaabb':(vi===0?'#1d6ef5':'#5a6a7e'))+';border-radius:4px;cursor:'+(dis?'not-allowed':'pointer')+';text-decoration:'+(dis?'line-through':'none')+'">'+(v.size_name || '—')+'</button>';
        }).join('') + '</div>' : '';
        return '<div data-group="'+gi+'" style="border:1px solid #e2e8f0;border-radius:8px;padding:10px;background:#fff">'
          + '<div style="height:120px;background:#f4f6fa;border-radius:6px;margin-bottom:8px;display:flex;align-items:center;justify-content:center;color:#9aaabb">'+(g.image_url?'<img src="'+g.image_url+'" style="max-width:100%;max-height:100%">':'📦')+'</div>'
          + '<div style="font-weight:600;font-size:14px;color:#1a2332;margin-bottom:4px;line-height:1.3">'+g.display_name+'</div>'
          + '<div style="display:flex;gap:6px;margin-bottom:4px;flex-wrap:wrap">'+colorChip+'</div>'
          + sizeButtons
          + '<div style="display:flex;justify-content:space-between;align-items:center;margin-top:6px">'
          +   '<strong class="hent-price" data-group="'+gi+'" style="color:#1d6ef5;font-size:15px">'+priceTxt+'</strong>'
          +   '<button data-group="'+gi+'" class="hent-add" '+(canAdd?'':'disabled')+' style="padding:5px 12px;background:'+(canAdd?'#1d6ef5':'#cbd5e1')+';color:#fff;border:0;border-radius:4px;cursor:'+(canAdd?'pointer':'not-allowed')+';font-size:12px">+ Sepete</button>'
          + '</div>'
          + '<div class="hent-stock" data-group="'+gi+'" style="font-size:11px;color:#9aaabb;margin-top:4px">Stok: '+firstV.stock+'</div>'
          + '</div>';
      }).join('');

      // Beden seç → aktif variant'ı sakla
      var selectedVi = {};
      groups.forEach(function(g,gi){ selectedVi[gi] = 0; });

      document.querySelectorAll('.hent-size').forEach(function(btn){
        btn.onclick = function(){
          if (btn.disabled) return;
          var gi = parseInt(btn.dataset.group), vi = parseInt(btn.dataset.vi);
          selectedVi[gi] = vi;
          // O grubun beden butonlarını yeniden boyut
          document.querySelectorAll('.hent-size[data-group="'+gi+'"]').forEach(function(b){
            var isActive = parseInt(b.dataset.vi) === vi;
            if (b.disabled) return;
            b.style.borderColor = isActive ? '#1d6ef5' : '#d1d9e0';
            b.style.background  = isActive ? 'rgba(29,110,245,0.1)' : '#fff';
            b.style.color       = isActive ? '#1d6ef5' : '#5a6a7e';
          });
          // Fiyat ve stok güncelle
          var v = groups[gi].variants[vi];
          var priceEl = document.querySelector('.hent-price[data-group="'+gi+'"]');
          priceEl.innerHTML = v.has_price ? (fmt(v.price) + ' ₺') : '<span style="color:#dc2626;font-size:12px;font-weight:600">Fiyat Tanımsız</span>';
          document.querySelector('.hent-stock[data-group="'+gi+'"]').textContent = 'Stok: ' + v.stock;
          var addBtn = document.querySelector('.hent-add[data-group="'+gi+'"]');
          var canAdd = v.has_price && v.stock > 0;
          addBtn.disabled = !canAdd;
          addBtn.style.background = canAdd ? '#1d6ef5' : '#cbd5e1';
          addBtn.style.cursor = canAdd ? 'pointer' : 'not-allowed';
        };
      });

      document.querySelectorAll('.hent-add').forEach(function(btn){
        btn.onclick = function(){
          if (btn.disabled) return;
          var gi = parseInt(btn.dataset.group);
          var vi = selectedVi[gi] || 0;
          var g = groups[gi];
          var v = g.variants[vi];
          if (!v.has_price) { alert('Bu varyantın e-ticaret fiyatı tanımlanmamış'); return; }
          if (v.stock <= 0) { alert('Bu varyant stokta yok'); return; }
          var label = g.display_name + (g.color_name ? ' · ' + g.color_name : '') + (v.size_name ? ' · ' + v.size_name : '');
          var ex = cart.find(function(c){return c.id === v.id;});
          if (ex) ex.qty++;
          else cart.push({id: v.id, stock_id: v.id, stock_name: label, unit_price: v.price, qty: 1});
          document.getElementById('hent-cart-n').textContent = cart.reduce(function(a,c){return a+c.qty;},0);
          btn.textContent = '✓ Eklendi';
          setTimeout(function(){btn.textContent='+ Sepete';},700);
        };
      });
    });
  }

  function openCart(){
    if (!cart.length){ alert('Sepetiniz boş'); return; }
    var total = cart.reduce(function(a,c){return a+c.unit_price*c.qty;},0);
    var html = '<div style="position:fixed;inset:0;background:rgba(0,0,0,0.5);z-index:9999;display:flex;align-items:center;justify-content:center;padding:14px"><div style="background:#fff;border-radius:10px;max-width:520px;width:100%;padding:18px;max-height:90vh;overflow:auto"><div style="display:flex;justify-content:space-between;margin-bottom:12px"><h3 style="margin:0">Sepet</h3><button id="hent-close" style="background:none;border:0;font-size:22px;cursor:pointer">×</button></div>';
    cart.forEach(function(c,i){
      html += '<div style="display:flex;gap:8px;padding:8px 0;border-bottom:1px solid #e2e8f0;align-items:center"><span style="flex:1">'+c.stock_name+'</span><input type="number" min="1" value="'+c.qty+'" data-i="'+i+'" class="hent-q" style="width:55px;padding:4px;border:1px solid #d1d9e0;border-radius:4px"><strong style="width:90px;text-align:right">'+fmt(c.unit_price*c.qty)+' ₺</strong><button data-i="'+i+'" class="hent-rm" style="background:none;border:0;color:#dc2626;cursor:pointer">×</button></div>';
    });
    html += '<div style="display:flex;justify-content:space-between;padding:10px 0;font-size:16px;font-weight:700"><span>Toplam:</span><span>'+fmt(total)+' ₺</span></div><form id="hent-order-form" style="display:flex;flex-direction:column;gap:8px"><input name="customer_name" required placeholder="Ad Soyad *" style="padding:10px;border:1px solid #d1d9e0;border-radius:6px"><input name="customer_email" type="email" placeholder="E-posta" style="padding:10px;border:1px solid #d1d9e0;border-radius:6px"><input name="customer_phone" type="tel" placeholder="Telefon" style="padding:10px;border:1px solid #d1d9e0;border-radius:6px"><textarea name="shipping_address" rows="2" placeholder="Teslimat adresi" style="padding:10px;border:1px solid #d1d9e0;border-radius:6px;font-family:inherit"></textarea><button type="submit" style="padding:12px;background:#10b981;color:#fff;border:0;border-radius:6px;font-weight:600;cursor:pointer">Siparişi Tamamla</button><div id="hent-order-msg" style="text-align:center;font-size:13px"></div></form></div></div>';
    var modal = document.createElement('div');
    modal.innerHTML = html;
    document.body.appendChild(modal);
    document.getElementById('hent-close').onclick = function(){ modal.remove(); };
    modal.querySelectorAll('.hent-rm').forEach(function(b){ b.onclick = function(){ cart.splice(parseInt(b.dataset.i),1); modal.remove(); openCart(); }; });
    modal.querySelectorAll('.hent-q').forEach(function(inp){ inp.onchange = function(){ cart[parseInt(inp.dataset.i)].qty = parseInt(inp.value)||1; modal.remove(); openCart(); }; });
    document.getElementById('hent-order-form').addEventListener('submit', function(e){
      e.preventDefault();
      var fd = Object.fromEntries(new FormData(e.target).entries());
      fd.items = cart.map(function(c){return {stock_id:c.stock_id, stock_name:c.stock_name, quantity:c.qty, unit_price:c.unit_price};});
      var msg = document.getElementById('hent-order-msg');
      msg.textContent = 'Gönderiliyor...'; msg.style.color='#5a6a7e';
      fetch(API+'/order/'+CODE,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(fd)}).then(function(r){return r.json();}).then(function(j){
        if (j.success){ msg.style.color='#16a34a'; msg.textContent='Sipariş alındı: '+j.data.order_number; cart=[]; document.getElementById('hent-cart-n').textContent=0; setTimeout(function(){modal.remove();},2500); }
        else { msg.style.color='#dc2626'; msg.textContent = j.message||'Hata'; }
      }).catch(function(){ msg.style.color='#dc2626'; msg.textContent='Bağlantı hatası'; });
    });
  }

  renderCatalog();
})();
</script>
<!-- hent E-Ticaret Katalog — son -->`;

  const apiCatalog = `// Katalog çek (yayımlanmış ürünler)
fetch('${API_BASE}/api/ecom/public/catalog/${code}?search=BMW').then(r=>r.json()).then(console.log);`;

  const apiOrder = `// Sipariş gönder
fetch('${API_BASE}/api/ecom/public/order/${code}', {
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify({
    customer_name: 'Ahmet Yılmaz',
    customer_email: 'ahmet@example.com',
    customer_phone: '0532...',
    shipping_address: 'Mahalle, sokak, no...',
    items: [
      { stock_id: '<uuid>', stock_name: 'Ürün', quantity: 2, unit_price: 150.00 },
    ],
  }),
}).then(r => r.json()).then(console.log);`;

  const copy = (text, key) => {
    navigator.clipboard.writeText(text).then(() => {
      setCopied(key);
      toast.success('Panoya kopyalandı');
      setTimeout(() => setCopied(null), 2000);
    });
  };

  return (
    <div className="stocks-page" style={{ padding: 0, display: 'flex', flexDirection: 'column', height: '100%' }}>
      <ListPageHeader title="E-Ticaret Katalog Embed" unit="" count={null} />

      <div style={{ padding: 16, maxWidth: 1100, margin: '0 auto', width: '100%', flex: 1, overflowY: 'auto', overflowX: 'hidden' }}>
        <div style={S.infoBox}>
          <strong style={{ color: 'var(--accent-primary)' }}>🛒 E-Ticaret Katalog Embed</strong>
          <p style={S.infoP}>
            Aşağıdaki kodu kendi web sitenize yapıştırın. Müşteri ürünleri görür, sepete ekler, sipariş gönderir.
            Sipariş <strong>otomatik olarak hent'te</strong> görünür (E-Ticaret Siparişleri sayfası).
          </p>
          <ul style={S.infoUl}>
            <li>✓ Sadece <strong>"E-Ticaret'te göster"</strong> işaretli stoklar görünür (Stok kartında <code>is_published=1</code>)</li>
            <li>✓ Fiyatlar <strong>"ETicaret"</strong> fiyat grubundaki tanımdan çekilir (Program Tanımları → Fiyat Tanımları)</li>
            <li>✓ Sipariş geldiğinde push bildirim gelir</li>
            <li>✓ Tek script — bağımsız, hiçbir kütüphane gerektirmez</li>
          </ul>
        </div>

        <section style={S.section}>
          <h3 style={S.h3}>📋 Canlı Önizleme</h3>
          <div style={S.previewWrap}>
            <iframe
              title="Katalog Önizleme"
              srcDoc={htmlSnippet}
              style={S.iframe}
              sandbox="allow-scripts allow-forms allow-same-origin"
            />
            <div style={{ fontSize: 'var(--text-xs)', color: 'var(--text-tertiary)', marginTop: 8, textAlign: 'center' }}>
              Bu önizleme gerçek API'ye gider — <strong>{company?.code}</strong> şirketinin yayımlanmış stoklarını gösterir.
            </div>
          </div>
        </section>

        <section style={S.section}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
            <h3 style={S.h3}>📄 HTML/JS Embed Kodu</h3>
            <Button size="sm" onClick={() => copy(htmlSnippet, 'html')}>
              {copied === 'html' ? '✓ Kopyalandı' : '📋 Kopyala'}
            </Button>
          </div>
          <pre style={S.pre}>{htmlSnippet}</pre>
        </section>

        <section style={S.section}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
            <h3 style={S.h3}>⚡ REST API (Programatik)</h3>
            <div style={{ display: 'flex', gap: 6 }}>
              <Button size="sm" onClick={() => copy(apiCatalog, 'api-cat')}>{copied === 'api-cat' ? '✓' : 'Katalog Kopyala'}</Button>
              <Button size="sm" onClick={() => copy(apiOrder, 'api-ord')}>{copied === 'api-ord' ? '✓' : 'Sipariş Kopyala'}</Button>
            </div>
          </div>
          <pre style={S.pre}>{apiCatalog + '\n\n' + apiOrder}</pre>
        </section>

        <section style={S.section}>
          <h3 style={S.h3}>⚙ Kurulum Adımları</h3>
          <ol style={{ margin: 0, paddingLeft: 22, fontSize: 'var(--text-sm)', color: 'var(--text-secondary)', lineHeight: 1.7 }}>
            <li>Stoklar sayfasından satılacak ürünleri açın, <strong>"E-Ticaret'te göster"</strong> alanını işaretleyin (is_published=1).</li>
            <li>Fiyat Tanımları'nda <strong>"ETicaret"</strong> grubunda bir fiyat tanımı oluşturun ve stok kartından fiyat girin (yoksa ürün "Fiyat Tanımsız" görünür ve sepete eklenemez).</li>
            <li>Yukarıdaki HTML kodunu sitenizin bir sayfasına yapıştırın.</li>
            <li>Müşteri formu doldurur, sipariş <strong>E-Ticaret Siparişleri</strong>'nde görünür.</li>
            <li>Siparişe tıklayın → durumu güncelleyin (Beklemede → Onaylandı → Hazırlanıyor → Kargoda → Teslim).</li>
          </ol>
        </section>
      </div>
    </div>
  );
}

const S = {
  infoBox: {
    padding: 14,
    background: 'var(--accent-glow)',
    border: '1px solid var(--border-primary)',
    borderRadius: 'var(--r-md)',
    marginBottom: 16,
  },
  infoP: { fontSize: 'var(--text-sm)', color: 'var(--text-secondary)', margin: '8px 0', lineHeight: 1.6 },
  infoUl: { margin: '0', paddingLeft: 18, fontSize: 'var(--text-sm)', color: 'var(--text-secondary)' },
  section: {
    background: 'var(--bg-card)',
    border: '1px solid var(--border-secondary)',
    borderRadius: 'var(--r-md)',
    padding: 14,
    marginBottom: 14,
    boxShadow: 'var(--shadow-xs)',
  },
  h3: { fontSize: 'var(--text-md)', fontWeight: 700, color: 'var(--text-primary)', margin: 0 },
  previewWrap: {
    padding: 12,
    background: 'var(--bg-card-hover)',
    border: '1px dashed var(--border-secondary)',
    borderRadius: 'var(--r-md)',
  },
  iframe: { width: '100%', height: 560, border: 'none', background: '#fff', borderRadius: 6 },
  pre: {
    background: '#0f172a',
    color: '#e2e8f0',
    padding: 14,
    borderRadius: 'var(--r-md)',
    overflowX: 'auto',
    fontSize: 11,
    fontFamily: 'JetBrains Mono, monospace',
    lineHeight: 1.5,
    margin: 0,
    maxHeight: 500,
    overflowY: 'auto',
  },
};
